/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import React from 'react';
import NotificationTableApp from "./NotificationTableApp";
import CustomTable from "../../../../../components/table/CustomTable";
import {permissionObj} from "../../../../../Helpers/permission"; // Importing the CustomTable component

const NotificationSectionTable = (props) => {
    // Destructuring props to extract relevant values and functions for this component
    const { isAllChecked,  selectedList} = props;

    // Destructuring additional values and methods from NotificationTableApp component
    const {
        DEV, // Development environment flag
        permission, // Permissions related to the user
        contractorId,
        supplierId,
        tableId, // The ID for the table
        searchId, // The ID for the search input
        thead, // The table header content
        tbody, // The table body content
        getActionsButtons, // Function to retrieve action buttons for each row
        handleCheckboxChange, // Handler for individual checkbox changes
        handleDeleteAll,
        pagination, // Function to render pagination controls
    } = NotificationTableApp(props);

    return (
        <>
            {/* Rendering the CustomTable component with the necessary props */}
            <CustomTable
                tableId={tableId} // Table ID
                searchId={searchId} // ID for the search input field
                checkbox={(contractorId || supplierId || DEV || permission?.includes(permissionObj?.WEB_ANNOUNCEMENT_DELETE))} // Enable checkboxes if in DEV environment and the user has permission
                checkboxTitle={"de_/_select_all"} // Title for the "Select All / Deselect All" checkbox
                isAllChecked={isAllChecked} // Whether all checkboxes are selected
                onChangeCheckbox={handleDeleteAll} // Function to handle checkbox state changes
                thead={thead} // The table header
                tbody={tbody} // The table body data
                columnActions={true} // Enable actions for each column
                getActionsButtons={getActionsButtons} // Function to generate action buttons for each row
                handleCheckboxChange={handleCheckboxChange} // Handler for checkbox change on individual rows
                selectedList={selectedList} // List of selected rows
            />
            {/* Rendering pagination control */}
            { pagination() } {/* Function to render pagination */}
        </>
    );
};

// Exporting the NotificationSectionTable component to be used elsewhere in the application
export default NotificationSectionTable;
